module.exports = __webpack_public_path__ + "img/homepage_2--mobile@3x.65da33dc.jpg";